import { useRecord } from "./useRecord";

export function useTag(tagId?: string | null) {
  return useRecord("tag", tagId);
}
